<template>
  <div id="login_bg">
    <div id="login">
      <aside>
        <figure>
          <a>
            <img src="@/assets/logo.jpg" data-retina="true" alt class="logo_sticky">
          </a>
        </figure>
        <form @submit.prevent="login">
          <div class="form-group">
            <label>Email</label>
            <input type="email" class="form-control" name="email" id="email" v-model="email">
            <i class="icon_mail_alt"></i>
          </div>
          <div class="form-group">
            <label>Password</label>
            <input
              type="password"
              class="form-control"
              name="password"
              id="password"
              v-model="password"
            >
            <i class="icon_lock_alt"></i>
          </div>
          <p
            class="text-danger"
            v-if="error"
          >Login failed! Please check your credentials and try again.</p>
          <button type="submit" class="btn_1 rounded full-width">Login to The Eighth</button>
        </form>
        <div class="copy">Eighth Concierge</div>
      </aside>
    </div>
  </div>
</template>

<script>
import { FirebaseAuth } from '@/library/firebase'

export default {
  data () {
    return {
      email: '',
      password: '',
      error: false
    }
  },
  methods: {
    login () {
      FirebaseAuth.signInWithEmailAndPassword(this.email, this.password)
        .catch(e => {
          this.error = true
        })
    }
  },
  created () {
    FirebaseAuth.onAuthStateChanged((user) => {
      if (user) {
        this.$store.commit('SET_LOGGEDIN', user.uid)
        this.$store.dispatch('init')
        this.$router.push('/')
      }
    })
  }
}
</script>

<style lang="scss">
</style>
